import {
  ADD_COUPON_PRODUCT_TO_CART_LIST,
  ADD_COUPON_PRODUCT_TO_CART_LIST_SUCCESS,
  ADD_COUPON_PRODUCT_TO_CART_LIST_FAILURE,

  FETCH_COUPON_CART_LIST,
  FETCH_COUPON_CART_LIST_SUCCESS,
  FETCH_COUPON_CART_LIST_FAILURE,


    REMOVE_COUPON_TO_CART_LIST,
    REMOVE_COUPON_TO_CART_LIST_SUCCESS,
    REMOVE_COUPON_TO_CART_LIST_FAILURE,

    SET_COUPON_DESCRIPTION_MODAL_VISIBLE,
    SET_SELECTED_COUPON,
    SET_CLIPPING_PRODUCT_ID,
  } from "redux/constants/actionTypes";
  import axios from "config/axios";
  
  // fetch shopping cart data
   
   
   
  //  add to cart list
  
  export const addCouponToCartList = (payload) => {
    return {
      type: ADD_COUPON_PRODUCT_TO_CART_LIST,
      payload: payload,
    };
  };

export const addCouponToCartListSuccess = (payload) => {
  return {
    type: ADD_COUPON_PRODUCT_TO_CART_LIST_SUCCESS,
    payload: payload,
  };
};

  export const addCouponToCartListFailure = (payload) => {
    return {
      type: ADD_COUPON_PRODUCT_TO_CART_LIST_FAILURE,
      payload: payload,
    };
  };

export const addcouponToCart = (body) => async (dispatch) => {
  dispatch(addCouponToCartList());

  return axios
    .post("/AogAddToCartCoupons", body)
    .then((res) => {
      // passing blank object so at least it can reset loading status
      dispatch(addCouponToCartListSuccess({}));
    })
    .catch((error) => {
      dispatch(addCouponToCartListFailure({ error: error.data.message }));
    });
};


//fetch coupon cart list
export const fetchcouponCartList = (payload) => {
  return {
    type: FETCH_COUPON_CART_LIST,
    payload: payload,
  };
};
export const fetchcouponCartListSuccess = (payload) => {
  return {
    type: FETCH_COUPON_CART_LIST_SUCCESS,
    payload: payload,
  };
};
export const fetchcpouponCartListFailure = (payload) => {
  return {
    type: FETCH_COUPON_CART_LIST_FAILURE,
    payload: payload,
  };
};

//remove coupon from cart list
export const removecouponCartList = (payload) => {
  return {
    type: REMOVE_COUPON_TO_CART_LIST,
    payload: payload,
  };
};
export const removecouponCartListSuccess = (payload) => {
  return {
    type: REMOVE_COUPON_TO_CART_LIST_SUCCESS,
    payload: payload,
  };
};
export const removecpouponCartListFailure = (payload) => {
  return {
    type: REMOVE_COUPON_TO_CART_LIST_FAILURE,
    payload: payload,
  };
};

export const getcouponcartlist = (body) => async (dispatch) => {
  dispatch(fetchcouponCartList());

  return axios
    .post("/AogGetMyCouponsCartDetails", body)
    .then((res) => {
      dispatch(fetchcouponCartListSuccess(res.data.data.MyCartInfo));
    })
    .catch((error) => {
      dispatch(fetchcpouponCartListFailure({ error: error.data.message }));
    });
  };
  export const getremoveCouponcartlist = (body) => async (dispatch) => {
    dispatch(removecouponCartList());

    return axios
      .post("/AogRemoveFromCartCoupons", body)
      .then((res) => {
        dispatch(removecouponCartListSuccess({offer_id: body.offer_id}));
      })
      .catch((error) => {
        dispatch(removecpouponCartListFailure({ error: error.data.message }));
      });
  };

  export const setCouponDescriptionModalVisible = (payload) => {
    return {
      type: SET_COUPON_DESCRIPTION_MODAL_VISIBLE,
      payload,
    };
  };
   
export const setSelectedCoupon = (payload) => {
  return {
    type: SET_SELECTED_COUPON,
    payload,
  };
};

export const setClippingProductId = (payload) => {
  return {
    type: SET_CLIPPING_PRODUCT_ID,
    payload,
  };
};